import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleSmallFilled = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 11.8333C8 9.71624 9.71624 8 11.8333 8C13.9504 8 15.6667 9.71624 15.6667 11.8333C15.6667 13.9504 13.9504 15.6667 11.8333 15.6667C9.71624 15.6667 8 13.9504 8 11.8333Z",
		fill: "currentColor"
	})]
});
export default SvgCircleSmallFilled;
